import React, { Component } from "react";
import FormTitle from "../FormTitle/FormTitle";
import ReactGA from "react-ga";
import FormController from "../../components/FormController/FormController";
import classes from "./FormChooseMySeats.module.scss";
import PlanRecommendation from "./PlanRecommendation/PlanRecommendation";
import PlanUpsell from "./PlanUpsell/PlanUpsell";
import PlanDownsell from "./PlanDownsell/PlanDownsell";
import ScheduleSelection from "./ScheduleSelection/ScheduleSelection";
import PreviewPlan from "./PreviewPlan";
import * as ROUTES from "../../constants/routes";
import { withRouter } from "react-router-dom";

class FormChooseMySeats extends Component {
  componentDidMount() {
    if (this.props.formStart === "") {
      this.props.history.push("/");
    } else {
      if (window.adobeAnalytics) {
        window.adobeAnalytics.t({
          pageName:
            "Washington Nationals: Tickets: Nationals Ticketfinder: We Recommend",
        });
      }
    }
    this.props.updateMultipleSelectedChoices({
      [ROUTES.PAGE_5_KEY]: "",
      selectYourSeatsUuid: "",
      seatInfoSelected: "",
      numOfSeat: "",
    });

    ReactGA.pageview("/recommended-plan");

    this.setState({ showPreviewPlan: false });
    if (this.props.isRedirect) {
      this.onClickShowScheduleSelection();
    }

    if (
      typeof this.props.history.location.state !== "undefined" &&
      this.props[ROUTES.PAGE_3_KEY]
    ) {
      if (this.props.history.location.state?.showModal) {
        this.setState({ showScheduleSelection: true });
      }
    }
    if (this.props.formStyle === "ballpark") {
      this.props.updateSelectedChoices(
        ROUTES.PAGE_3_KEY,
        ROUTES.PAGE_3_CHOICES_9
      );
    }
    this.createplans();
  }

  state = {
    showScheduleSelection: false,
    showPreviewPlan: false,
    planToPreview: "",
  };
  // componentDidUpdate(prevProps, prevState) {
  //   // Check if showScheduleSelection has changed
  //   if (prevState.showScheduleSelection !== this.state.showScheduleSelection) {
  //     console.log(
  //       "showScheduleSelection changed:",
  //       this.state.showScheduleSelection
  //     );
  //     if (this.state.showScheduleSelection) {
  //       document.body.style.overflow = "hidden";
  //     } else {
  //       document.body.style.overflow = "auto";
  //     }
  //     // Add any additional logic you need when showScheduleSelection changes
  //   }
  // }
  onClickDownsellSinglePage = () => {
    this.props.updateMultipleSelectedChoices({
      formSize: "",
      formStart: "",
      formStyle: "",
    });
    this.props.history.push("ticket-single-group");
    // this.props.history.push(`/ticket-single-group`, {
    //   hideMenu: true,
    // });
  };
  onClickChooseMyPlansToggle = (plan) => {
    this.setState({ showPreviewPlan: true });

    setTimeout(() => {
      switch (plan) {
        case ROUTES.PAGE_3_CHOICES_1:
        case ROUTES.PAGE_3_CHOICES_2:
        case ROUTES.PAGE_3_CHOICES_3:
        case ROUTES.PAGE_3_CHOICES_4:
        case ROUTES.PAGE_3_CHOICES_5:
          this.props.updateMultipleSelectedChoices({
            [ROUTES.PAGE_2_KEY]: "classic",
            [ROUTES.PAGE_3_KEY]: plan,
          });
          break;
        case ROUTES.PAGE_3_CHOICES_6:
        case ROUTES.PAGE_3_CHOICES_7:
        case ROUTES.PAGE_3_CHOICES_8:
          this.props.updateMultipleSelectedChoices({
            [ROUTES.PAGE_2_KEY]: "flexible",
            [ROUTES.PAGE_3_KEY]: plan,
          });
          break;
        case ROUTES.PAGE_3_CHOICES_9:
          this.props.updateMultipleSelectedChoices({
            [ROUTES.PAGE_2_KEY]: "ballpark",
            [ROUTES.PAGE_3_KEY]: plan,
          });
          break;
        default:
          break;
      }
      this.setState({ showPreviewPlan: false });
    }, 1000);

    this.setState({ showPreviewPlan: true });
  };
  onClickClosePreviewPlan = (plan) => {
    this.setState({ showPreviewPlan: false });
  };
  onClickShowScheduleSelection = () => {
    if (window.adobeAnalytics && window.adobeAnalytics.tl) {
      window.adobeAnalytics.tl(
        true,
        "o",
        `Washington Nationals: Tickets: Nationals Ticketfinder: We Recommend: we recommend: ${
          this.props[ROUTES.PAGE_3_KEY]
        } : show me my seats button click`,
        {
          prop12: "Nationals TicketFinder",
          prop13:
            "Washington Nationals: Tickets: Nationals Ticketfinder: We Recommend",
          prop14: `we recommend: ${
            this.props[ROUTES.PAGE_3_KEY]
          } : show me my seats button click`,
        }
      );
    }
    // console.log("clicked open");

    switch (this.props[ROUTES.PAGE_3_KEY]) {
      // Classic
      case ROUTES.PAGE_3_CHOICES_1:
        this.props.updateSelectedChoices("selectYourSeatsUuid", "xa79PAlovb");
        this.props.history.push("select-your-seats");
        break;
      case ROUTES.PAGE_3_CHOICES_2:
      case ROUTES.PAGE_3_CHOICES_3:
      case ROUTES.PAGE_3_CHOICES_4:
      case ROUTES.PAGE_3_CHOICES_5:
        this.setState({ showScheduleSelection: true });
        break;
      // Flex
      case ROUTES.PAGE_3_CHOICES_6:
        this.props.updateSelectedChoices("selectYourSeatsUuid", "6WPuBrtT8C");
        this.props.history.push("select-your-seats");
        break;
      case ROUTES.PAGE_3_CHOICES_7:
        this.props.updateSelectedChoices("selectYourSeatsUuid", "yHsZtmvU3N");
        this.props.history.push("select-your-seats");
        break;
      case ROUTES.PAGE_3_CHOICES_8:
        this.props.updateSelectedChoices("selectYourSeatsUuid", "LHsIqghb0k");
        this.props.history.push("select-your-seats");
        break;
      //Ballpark
      case ROUTES.PAGE_3_CHOICES_9:
        this.setState({ showScheduleSelection: true });
        this.onClickScheduleSelected("soof513JuY");
        break;
      default:
        break;
    }
  };
  onClickCloseScheduleSelection = () => {
    this.setState({ showScheduleSelection: false });
  };
  onClickSwitchPlan = () => {
    switch (this.state.planToPreview) {
      case ROUTES.PAGE_3_CHOICES_1:
      case ROUTES.PAGE_3_CHOICES_2:
      case ROUTES.PAGE_3_CHOICES_3:
      case ROUTES.PAGE_3_CHOICES_4:
      case ROUTES.PAGE_3_CHOICES_5:
        this.props.updateMultipleSelectedChoices({
          [ROUTES.PAGE_2_KEY]: "classic",
          [ROUTES.PAGE_3_KEY]: this.state.planToPreview,
        });
        break;
      case ROUTES.PAGE_3_CHOICES_6:
      case ROUTES.PAGE_3_CHOICES_7:
      case ROUTES.PAGE_3_CHOICES_8:
        this.props.updateMultipleSelectedChoices({
          [ROUTES.PAGE_2_KEY]: "flexible",
          [ROUTES.PAGE_3_KEY]: this.state.planToPreview,
        });
        break;
      case ROUTES.PAGE_3_CHOICES_9:
        this.props.updateMultipleSelectedChoices({
          [ROUTES.PAGE_2_KEY]: "ballpark",
          [ROUTES.PAGE_3_KEY]: this.state.planToPreview,
        });
        break;
      default:
        break;
    }

    this.setState({ showPreviewPlan: false });
  };
  onClickScheduleSelected = (uuid) => {
    this.props.updateSelectedChoices("selectYourSeatsUuid", uuid);
    this.props.history.push("select-your-seats");
  };

  async createplans() {
    if (this.props.cms) {
      const _planRecommendationValues = {};
      const _planUpsellValues = {};
      const _planDownsellValues = {};
      const _scheduleSelectionValues = {};
      const cms = this.props.cms;

      await cms.forEach(async (style, index) => {
        await style.plans.forEach((plan) => {
          let _planSchedules = [];
          let _upsellBenefits = [];
          if (plan.recomUpsell) {
            _upsellBenefits = plan.recomUpsell?.map(({ name }) => name);
          }
          plan.schedules.forEach((shcedule) => {
            _planSchedules.push({
              title: shcedule.name,
              description: shcedule.desc,
              gamesTitle: plan.name,
              soldOut: shcedule.soldOut,
              buildPlan: shcedule.buildPlan,
              buttonUrl: shcedule.buttonUrl,
              uuid: shcedule.UUID,
              games: shcedule?.games?.map(({ info }) => info),
            });
          });

          _planRecommendationValues[plan.sizePlanChoice] = {
            slug: plan.sizePlanChoice,
            plan: plan.name,
            priceRange: `${plan.priceStart} - ${plan.priceEnd}`,
            priceStart: plan.priceStart,
            priceEnd: plan.priceEnd,
            avgSavings: plan.sizeAvgSavings,
            blurb: plan.recomDesc,
            subBlurb: plan.recomDescFootnote,
            buttonText: plan.recomButton,
            exclusivity: plan.recomExclusivity?.map(({ name }) => name),
            savings: plan.recomSavings?.map(({ name }) => name),
            convenience: plan.recomConvenience?.map(({ name }) => name),
          };

          _scheduleSelectionValues[plan.sizePlanChoice] = {
            header: plan.scheduleDesc1,
            subHeader: plan.scheduleDesc2,
            plan: _planSchedules,
          };

          _planUpsellValues[plan.sizePlanChoice] = {
            slug: plan.sizePlanChoice,
            plan: plan.name,
            priceRange: plan.priceStart,
            avgSavings: plan.sizeAvgSavings,
            benefits: _upsellBenefits,
          };

          _planDownsellValues[plan.sizePlanChoice] = {
            slug: plan.sizePlanChoice,
            plan: plan.name,
            priceRange: plan.priceStart,
          };
        });
      });

      this.setState({
        planRecommendationValues: _planRecommendationValues,
        planUpsellValues: _planUpsellValues,
        planDownsellValues: {
          singleGame: {
            slug: "singleGame",
            plan: "Single-Game Tickets",
            priceRange: "$9",
          },
          ..._planDownsellValues,
        },
        scheduleSelectionValues: _scheduleSelectionValues,
      });
    }
  }
  render() {
    if (
      !this.state.planRecommendationValues ||
      !this.state.planUpsellValues ||
      !this.state.planDownsellValues
    ) {
      return <p>Loading ...</p>;
    }
    let planRecommendationSelected = "";
    let planUpsellValuesSelected = "";
    let planDownsellValuesSelected = "";
    if (
      typeof this.props[ROUTES.PAGE_3_KEY] !== "undefined" ||
      this.props[ROUTES.PAGE_3_KEY] !== ""
    ) {
      switch (this.props[ROUTES.PAGE_3_KEY]) {
        case ROUTES.PAGE_3_CHOICES_1:
          planRecommendationSelected =
            this.state.planRecommendationValues["eightyClassic"];
          planUpsellValuesSelected = "";
          // planDownsellValuesSelected =
          //   this.state.planDownsellValues["fortyClassic"];
          break;
        case ROUTES.PAGE_3_CHOICES_2:
          planRecommendationSelected =
            this.state.planRecommendationValues["fortyClassic"];
          // planUpsellValuesSelected =
          //   this.state.planUpsellValues["eightyClassic"];
          // planDownsellValuesSelected =
          //   this.state.planDownsellValues["twentyClassic"];
          break;
        case ROUTES.PAGE_3_CHOICES_3:
          planRecommendationSelected =
            this.state.planRecommendationValues["twentyClassic"];
          // planUpsellValuesSelected =
          //   this.state.planUpsellValues["fortyClassic"];
          // planDownsellValuesSelected =
          //   this.state.planDownsellValues["tenClassic"];
          break;
        case ROUTES.PAGE_3_CHOICES_4:
          planRecommendationSelected =
            this.state.planRecommendationValues["tenClassic"];
          // planUpsellValuesSelected =
          //   this.state.planUpsellValues["twentyClassic"];
          // planDownsellValuesSelected =
          //   this.state.planDownsellValues["fiveClassic"];
          break;
        case ROUTES.PAGE_3_CHOICES_5:
          planRecommendationSelected =
            this.state.planRecommendationValues["fiveClassic"];
          // planUpsellValuesSelected = this.state.planUpsellValues["tenClassic"];
          // planDownsellValuesSelected = "";
          //  Uncomment when single game works
          // planDownsellValuesSelected =
          //   this.state.planDownsellValues["singleGame"];
          break;
        case ROUTES.PAGE_3_CHOICES_6:
          planRecommendationSelected =
            this.state.planRecommendationValues["eightyFlexible"];
          // planUpsellValuesSelected =
          //   this.state.planUpsellValues["eightyClassic"];
          // planDownsellValuesSelected =
          //   this.state.planDownsellValues["fortyFlexible"];
          break;
        case ROUTES.PAGE_3_CHOICES_7:
          planRecommendationSelected =
            this.state.planRecommendationValues["fortyFlexible"];
          // planUpsellValuesSelected =
          //   this.state.planUpsellValues["eightyFlexible"];
          // planDownsellValuesSelected =
          //   this.state.planDownsellValues["twentyFlexible"];
          break;
        case ROUTES.PAGE_3_CHOICES_8:
          planRecommendationSelected =
            this.state.planRecommendationValues["twentyFlexible"];
          // planUpsellValuesSelected =
          //   this.state.planUpsellValues["fortyFlexible"];
          // planDownsellValuesSelected =
          //   this.state.planDownsellValues["fiveClassic"];
          break;
        case ROUTES.PAGE_3_CHOICES_9:
          planRecommendationSelected =
            this.state.planRecommendationValues["eightyBallpark"];
          // planUpsellValuesSelected =
          //   this.state.planUpsellValues["eightyFlexible"];
          // planDownsellValuesSelected =
          //   this.state.planDownsellValues["tenClassic"];
          break;
        default:
      }
    }

    return (
      <div>
        <div>
          <FormTitle title="" />
          {planRecommendationSelected !== "" ||
          planUpsellValuesSelected !== "" ||
          planDownsellValuesSelected !== "" ? (
            <>
              <div className={classes.PlansWrapper}>
                <div className={classes.leftPlans}>
                  {planRecommendationSelected ? (
                    <>
                      <PlanRecommendation
                        planRecommendationSelected={planRecommendationSelected}
                        onClickShowScheduleSelection={
                          this.onClickShowScheduleSelection
                        }
                        planType={this.props.planType}
                        formSize={this.props.formSize}
                      />
                      <PreviewPlan
                        showPreviewPlan={this.state.showPreviewPlan}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className={classes.rightPlans}>
                  {/* <div className={classes.loyalty}>
                    <h3>Receive a</h3>
                    <h2>
                      FREE 50%
                      <br />
                      Bonus Credit*
                    </h2>
                    <h4>
                      based on the amount paid towards your 2021 ticket plan by
                      December 15!
                    </h4>
                    <p>
                      You can use this FREE 50% Bonus Credit for concessions,
                      merchandise, additional tickets and more! Alternatively,
                      use your bonus credit to donate tickets to first
                      responders and frontline workers, youth from local
                      communities and military service members and their
                      families. This limited-time offer ends December 15, so act
                      now!
                    </p>
                  </div> */}

                  {planUpsellValuesSelected ? (
                    <PlanUpsell
                      planUpsellValuesSelected={planUpsellValuesSelected}
                      planRecommendationSelected={planRecommendationSelected}
                      onClickChooseMyPlansToggle={
                        this.onClickChooseMyPlansToggle
                      }
                    />
                  ) : (
                    ""
                  )}
                  {planDownsellValuesSelected ? (
                    <PlanDownsell
                      planDownsellValuesSelected={planDownsellValuesSelected}
                      onClickChooseMyPlansToggle={
                        this.onClickChooseMyPlansToggle
                      }
                      onClickDownsellSinglePage={this.onClickDownsellSinglePage}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <FormController
                backTo={
                  this.props.formStyle === "ballpark"
                    ? ROUTES.PAGE_2_LINK
                    : ROUTES.PAGE_3_LINK
                }
                nextTo={ROUTES.PAGE_5_LINK}
                startOver={ROUTES.PAGE_1_LINK}
                showBack={true}
                showStartOver={true}
                showSkip={false}
                showSubmit={true}
                onSubmit={() => this.onClickShowScheduleSelection()}
              />
            </>
          ) : (
            <div className={classes.errorMsg}>Please choose a package</div>
          )}
        </div>
        <ScheduleSelection
          schedulePlan={this.props[ROUTES.PAGE_3_KEY]}
          showScheduleSelection={this.state.showScheduleSelection}
          onClickCloseScheduleSelection={this.onClickCloseScheduleSelection}
          onClickScheduleSelected={this.onClickScheduleSelected}
          scheduleSelectionValues={this.state.scheduleSelectionValues}
        />
      </div>
    );
  }
}

export default withRouter(FormChooseMySeats);
